import React, { useRef, useState } from "react";
import {
    I2cInput,
    I2cCheckboxGroup,
    I2cListItem,
    I2cCheckbox, I2cRadioGroup, I2cRadioButton
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { cardServiceOption } from "./stringUtils";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
const ManageProfile = ({ control, handleValueChanges, methods, errors, appSelectionForProgram }) => {

    const handleCheckboxChange = (event, fieldName) => {
        const SelectedNetworkValue = event;
        let updatedSelectedNetworks = [
            ...(methods.getValues(fieldName) ?? []),
        ];
        if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
            updatedSelectedNetworks = updatedSelectedNetworks.filter(
                (card) => card !== SelectedNetworkValue,
            );
        } else {
            updatedSelectedNetworks.push(SelectedNetworkValue);
        }
        methods.setValue(fieldName, updatedSelectedNetworks);
        methods.trigger();
        handleValueChanges();
    };
    return (
        <>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Manage Profile
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label mb-8">
                        This feature is required for:
                    </div>
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_manage_profile_feature_required_for"
                            control={control}
                            render={({ field }) => (
                                <>
                                    <I2cCheckboxGroup
                                        {...field}
                                        className="centeredCheckbox checkbox-margin"
                                    >
                                        <div i2c-grid="grid gap-sm">
                                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                                                <I2cListItem
                                                    key={index}
                                                    i2c-grid="6@md"
                                                    variant="receipt"
                                                    label={card}
                                                    sublabel=""
                                                    value=""
                                                    type="checkbox"
                                                    checked={methods
                                                        .watch("card_management_feature_manage_profile_feature_required_for")
                                                        .includes(card)}
                                                    onI2cCheckboxClicked={(e) => {
                                                        handleCheckboxChange(card, "card_management_feature_manage_profile_feature_required_for");
                                                    }}
                                                >

                                                    <I2cCheckbox
                                                        slot="prefix"
                                                        name="card_management_feature_manage_profile_feature_required_for"
                                                        filled
                                                        value={card}
                                                        label=""
                                                        ignoreTab
                                                        checked={methods
                                                            .watch("card_management_feature_manage_profile_feature_required_for")
                                                            .includes(card)}
                                                        className="customCheckbox"
                                                    ></I2cCheckbox>
                                                </I2cListItem>
                                            ))}
                                        </div>
                                    </I2cCheckboxGroup>
                                    <ErrorMessage
                                        show={
                                            errors.card_management_feature_manage_profile_feature_required_for &&
                                                methods.formState.touchedFields.card_management_feature_manage_profile_feature_required_for
                                                ? true
                                                : false
                                        }
                                        message={
                                            errors.card_management_feature_manage_profile_feature_required_for?.message ?? "Invalid input"
                                        }
                                    />
                                </>
                            )}
                        />
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label mb-8">
                        Please select the fields that cardholders must verify to change the PIN.
                    </div>
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_manage_profile_info_verification_for_pin_change"
                            control={control}
                            render={({ field }) => (
                                <>
                                    <I2cCheckboxGroup
                                        {...field}
                                        className="centeredCheckbox checkbox-margin"
                                    >
                                        <div i2c-grid="grid gap-sm">
                                            {["Expiry Date", "Last 4 digits of SSN [for US only]", "Date of Birth", "Password"].map((card, index) => (
                                                <I2cListItem
                                                    key={index}
                                                    i2c-grid="6@md"
                                                    variant="receipt"
                                                    label={card}
                                                    sublabel=""
                                                    value=""
                                                    type="checkbox"
                                                    checked={methods
                                                        .watch("card_management_feature_manage_profile_info_verification_for_pin_change")
                                                        .includes(card)}
                                                    onI2cCheckboxClicked={(e) => {
                                                        handleCheckboxChange(card, "card_management_feature_manage_profile_info_verification_for_pin_change");
                                                    }}
                                                >

                                                    <I2cCheckbox
                                                        slot="prefix"
                                                        name="card_management_feature_manage_profile_info_verification_for_pin_change"
                                                        filled
                                                        value={card}
                                                        label=""
                                                        ignoreTab
                                                        checked={methods
                                                            .watch("card_management_feature_manage_profile_info_verification_for_pin_change")
                                                            .includes(card)}
                                                        className="customCheckbox"
                                                    ></I2cCheckbox>
                                                </I2cListItem>
                                            ))}
                                        </div>
                                    </I2cCheckboxGroup>
                                    <ErrorMessage
                                        show={
                                            errors.card_management_feature_manage_profile_info_verification_for_pin_change &&
                                                methods.formState.touchedFields.card_management_feature_manage_profile_info_verification_for_pin_change
                                                ? true
                                                : false
                                        }
                                        message={
                                            errors.card_management_feature_manage_profile_info_verification_for_pin_change?.message ?? "Invalid input"
                                        }
                                    />
                                </>
                            )}
                        />
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_manage_profile_enable_captcha"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Enable Captcha for these fields?"
                                    {...field}
                                    name="card_management_feature_manage_profile_enable_captcha"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((bc, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_management_feature_manage_profile_enable_captcha") === bc
                                            }
                                            value={bc}
                                        >
                                            {bc}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_management_feature_manage_profile_enable_captcha &&
                                    methods.formState.touchedFields.card_management_feature_manage_profile_enable_captcha
                                    ? true
                                    : false
                            }
                            message={errors.card_management_feature_manage_profile_enable_captcha?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
            </div>

        </>
    );
};

export default ManageProfile;
